import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Switch, Route } from 'react-router-dom';

import App from './App';

import Login from './Login/Login';
import Logout from './Logout/Logout';

import Stores from './Stores/Stores';
import StoreEditor from './Stores/StoreEditor';

import Categories from './Categories/Categories';
import CategoryEditor from './Categories/CategoryEditor';

import Kiosks from './Kiosks/Kiosks';
import KioskEditor from './Kiosks/KioskEditor';

import Amenities from './Amenities/Amenities';
import AmenityEditor from './Amenities/AmenityEditor';

import Floorplans from './Floorplans/Floorplans';
import AddFloorplan from './Floorplans/AddFloorplan';
import EditFloorplan from './Floorplans/EditFloorplan';

import Settings from './Settings/Settings';

import MediaManager from './MediaManager/MediaManager';
import MediaManagerEditor from './MediaManager/MediaManagerEditor';

import Events from './Events/Events';
import EventEditor from './Events/EventEditor';

import HomePage from '../pages/HomePage';


export default class MainRouter extends Component {
  constructor() {
    super();
    this.state = {
      navOpenState: {
        isOpen: true,
        width: 304,
      }
    }
  }

  getChildContext () {
    return {
      navOpenState: this.state.navOpenState,
    };
  }

  appWithPersistentNav = () => (props) => (
    <App
      onNavResize={this.onNavResize}
      {...props}
    />
  )

  onNavResize = (navOpenState) => {
    this.setState({
      navOpenState,
    });
  }

  render() {
    return (
      <Switch>
        <Route path="/login" component={Login} exact/>
        <Route path="/logout" component={Logout} exact/>
        <Route path="/">
          <App onNavResize={this.onNavResize} {...this.props}>
            <Route path="/" component={HomePage} exact/>
            <Route path="/pointofinterests" exact component={Stores} />
            <Switch>
              <Route path="/pointofinterests/add" component={StoreEditor} />
              <Route path="/pointofinterests/:id" component={StoreEditor} /> {/* add or :id */}
            </Switch>
            <Route path="/categories" exact component={Categories} />
            <Switch>
              <Route path="/categories/add" component={CategoryEditor} />
              <Route path="/categories/:id" component={CategoryEditor} /> {/* add or :id */}
            </Switch>
            <Route path="/kiosks" exact component={Kiosks} />
            <Switch>
              <Route path="/kiosks/add" component={KioskEditor} />
              <Route path="/kiosks/:id" component={KioskEditor} /> {/* add or :id */}
            </Switch>
            <Route path="/amenities" exact component={Amenities} />
            <Switch>
              <Route path="/amenities/add" component={AmenityEditor} />
              <Route path="/amenities/:id" component={AmenityEditor} /> {/* add or :id */}
            </Switch>
            <Switch>
              <Route exact path="/floorplans" component={Floorplans}/>
              <Route path="/floorplans/add" component={AddFloorplan}/>
              <Route path="/floorplans/edit/:id" component={EditFloorplan}/>
            </Switch>
            <Route path="/events" exact component={Events} />
            <Switch>
              <Route path="/events/add" component={EventEditor} />
              <Route path="/events/:id" component={EventEditor} /> {/* add or :id */}
            </Switch>
            <Route path="/medias" exact component={MediaManager} />
            <Switch>
              <Route path="/medias/add" component={MediaManagerEditor} />
              <Route path="/medias/:id" component={MediaManagerEditor} /> {/* add or :id */}
            </Switch>
            <Route path="/settings" component={Settings} />
          </App>
        </Route>
      </Switch>
    );
  }
}

MainRouter.childContextTypes = {
  navOpenState: PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/modules/MainRouter.js